// extracted by mini-css-extract-plugin
module.exports = {"mobile":"_2_xh9","root":"_13eGw","onImage":"_1ecOl"};